import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useMutation, useQuery, gql } from '@apollo/client'
import { saveQorConfiguration, getQorConfig } from '../../../apollo'
import {
  Box, Typography, Button, Alert, CircularProgress,
  FormControlLabel, Switch
} from '@mui/material'
import PaymentIcon from '@mui/icons-material/Payment'

const SAVE_QOR = gql`${saveQorConfiguration}`
const GET_QOR = gql`${getQorConfig}`

function Qor() {
  const { data } = useQuery(GET_QOR)
  const cfg = data?.qorConfig

  const [enabled, setEnabled] = useState(false)
  const [sandbox, setSandbox] = useState(true)
  const [hydrated, setHydrated] = useState(false)
  const [success, setSuccess] = useState('')
  const [error, setError] = useState('')

  // Hydrate once the query resolves.
  React.useEffect(() => {
    if (cfg && !hydrated) {
      setEnabled(!!cfg.enabled)
      setSandbox(!!cfg.sandbox)
      setHydrated(true)
    }
  }, [cfg, hydrated])

  const [mutate, { loading }] = useMutation(SAVE_QOR, {
    onCompleted: () => {
      setSuccess('QorCommerce configuration saved!')
      setError('')
      setTimeout(() => setSuccess(''), 3000)
    },
    onError: () => {
      setError('Failed to save configuration.')
      setSuccess('')
      setTimeout(() => setError(''), 3000)
    }
  })

  // The fee, commission and tax settings on this row are global and save
  // from the Platform Fees card.
  const handleSave = () => {
    mutate({ variables: { configurationInput: { enabled, sandbox } } })
  }

  return (
    <Box sx={{ borderRadius: '16px', border: '1px solid #e2e8f0', overflow: 'hidden', boxShadow: '0 2px 12px rgba(0,0,0,0.05)' }}>
      <Box sx={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a2f 60%, #166534 100%)', px: 2.5, py: 2, display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box sx={{ width: 36, height: 36, borderRadius: '10px', bgcolor: 'rgba(255,255,255,0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <PaymentIcon sx={{ color: '#86efac', fontSize: 18 }} />
        </Box>
        <Typography sx={{ fontWeight: 700, fontSize: '0.95rem', color: '#fff' }}>QorCommerce (Marketplace)</Typography>
      </Box>

      <Box sx={{ p: 2.5, bgcolor: '#fff' }}>
        <Typography variant="body2" sx={{ mb: 2, color: '#64748b' }}>
          Split-settlement marketplace payments. API keys live in backend env vars
          (QOR_APP_KEY / QOR_CLIENT_KEY / QOR_CHANNEL_KEY). Restaurants are
          boarded as sub-merchants from the Merchant Boarding page.
        </Typography>

        <FormControlLabel
          control={<Switch checked={enabled} onChange={e => setEnabled(e.target.checked)} />}
          label="Enable QorCommerce payments"
          sx={{ mb: 1, display: 'block' }}
        />
        <FormControlLabel
          control={<Switch checked={sandbox} onChange={e => setSandbox(e.target.checked)} />}
          label="Sandbox mode (test)"
          sx={{ mb: 2, display: 'block' }}
        />

        {success && <Alert severity="success" sx={{ mb: 1.5, borderRadius: '10px', fontSize: '0.82rem' }}>{success}</Alert>}
        {error && <Alert severity="error" sx={{ mb: 1.5, borderRadius: '10px', fontSize: '0.82rem' }}>{error}</Alert>}

        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            disabled={loading}
            onClick={handleSave}
            startIcon={loading ? <CircularProgress size={14} color="inherit" /> : null}
          >
            Save
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default withTranslation()(Qor)
